export enum PaypalRequestIntent {
  SALE = 'sale',
  CAPTURE = 'CAPTURE',
  ORDER = 'order',
}
